import styled from "styled-components";
import { TableContainer } from "../../styles";

export const COR_BORDA = "#E0E0E0";
export const COR_FAIXA_FUNDO = "#F8F8F8";
export const COR_FAIXA_TEXTO = "#808080";
export const COR_THEAD_FUNDO = "#F2F2F2";
export const COR_TEXTO = "#505050";

export const BoxComFaixa = styled.div`
  border-radius: 8px;
  border: 1px solid ${COR_BORDA};
  overflow: hidden;
  margin-bottom: 20px;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const FaixaTitulo = styled.div`
  background-color: ${COR_FAIXA_FUNDO};
  padding: 8px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${COR_FAIXA_TEXTO};
  border-bottom: 1px solid ${COR_BORDA};
`;

export const TableContainerEstiloExemplo = styled(TableContainer)`
  border: none;
  border-radius: 0;

  .data-table {
    font-size: 12px;
    border: none;
    thead {
      background-color: ${COR_THEAD_FUNDO};
      th {
        text-align: left;
        padding: 8px;
        font-weight: 500;
        font-size: 12px;
        color: ${({ theme }) => theme.colors.c000000};
        white-space: nowrap;
      }
    }
    tbody tr {
      td {
        padding: 8px;
        font-size: 12px;

        &.field-cell {
          text-align: left;
          padding: 8px;
          font-weight: 500;
          font-size: 12px;
          color: rgb(100, 116, 139);
          white-space: nowrap;
        }

        &.value-cell {
          color: ${({ theme }) => theme.colors.c000000};
        }
      }
    }
  }
`;
